import { useTranslation } from 'react-i18next';

import { ShieldIcon } from './ui';

/**
 * Footer trust strip shown on Dashboard + HowItWorks. Kept minimal
 * and non-obtrusive — informs without shouting.
 */
export function TrustStrip() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto mt-8 flex max-w-[320px] items-center justify-center gap-2 text-center">
      <span className="shrink-0 text-pb-accent">
        <ShieldIcon size={14} />
      </span>
      <p className="text-[11px] leading-snug text-tg-hint">
        {t('trust.footer')}
      </p>
    </div>
  );
}
